import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../scss/collect-card.scss';
import Color from '@tool/color';
import { CloseIcon20, ArrowDown, UpChangeIcon, DownChangeIcon } from '@styled/icon';
import { locateValue } from '@tool/index';
import moSalary from '../store/salary';
import moDashboard from '../../store';

interface IProps {
  overview: any,
}
interface IState {}

const CollectCard = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { overview } = props;
  const { collectType } = moDashboard;
  const { collectRecent, historyRecent } = moSalary;

  useEffect(() => {
    return () => {};
  }, []);

  // 第二个参数 - 保留几位小数
  const newRateValue = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return 0;
    if (value === null || value === '' || value === undefined) return 0;
    if (value === 0) return 0;
    const newValue = round(value * 100, digit);
    if (newValue === 0) return 0;
    return newValue;
  };

  // 第二个参数 - 保留几位小数
  const newRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return 0;
    const newValue = round(value * 100, digit);
    if (newValue === 0) return 0;
    return `${newValue}%`;
  };

  return (
    <section className="collect-card-11">
      <section className="section-6001 section-6006">
        <span className="text-6001">{collectType === 'collect' ? '收藏' : '历史查看'}职位总成本(年)</span>
        <span className="value-6001">
          <b>¥</b><strong className="mont-font">{locateValue(overview?.total_cost)}</strong>
        </span>
      </section>
      <section className="section-6001 section-6006">
        <span className="text-6001">职位平均年薪</span>
        <span className="value-6001">
          <b>¥</b><strong className="mont-font">{locateValue(overview?.avg_cost)}</strong>
        </span>
      </section>
      <section className="section-6001 section-6006">
        <span className="text-6001">{collectType === 'collect' ? collectRecent : historyRecent}平均年薪变化</span>
        <p className="value-6001">
          {newRateValue(overview?.avg_salary_change) > 0 ? <UpChangeIcon color={Color.red} /> : null}
          {newRateValue(overview?.avg_salary_change) < 0 ? <DownChangeIcon color={Color.success} /> : null}
          <strong className={[
            'mont-font', newRateValue(overview?.avg_salary_change) > 0 ? 'error-55' : 'success-55',
          ].join(' ')}>&nbsp;{newRate(overview?.avg_salary_change)}</strong>
        </p>
      </section>
      <section className="section-6001 section-6006">
        <span className="text-6001">{collectType === 'collect' ? collectRecent : historyRecent}平均招聘量变化</span>
        <p className="value-6001">
          {newRateValue(overview?.avg_amount_change) > 0 ? <UpChangeIcon color={Color.success} /> : null}
          {newRateValue(overview?.avg_amount_change) < 0 ? <DownChangeIcon color={Color.red} /> : null}
          <strong className={[
            'mont-font', newRateValue(overview?.avg_amount_change) > 0 ? 'error-55' : 'success-55',
          ].join(' ')}>&nbsp;{newRate(overview?.avg_amount_change)}</strong>
        </p>
      </section>
      <section className="section-6001 section-6006">
        <span className="text-6001">{collectType === 'collect' ? collectRecent : historyRecent}平均岗位热度</span>
        <strong className="mont-font error-55">{locateValue(overview?.avg_heat)}</strong>
      </section>
      <section className="section-6001">
        <span className="text-6001">职位异动</span>
        <section className="value-6006">
          <p className="line-55">
            <span className="rise-11">招聘量大幅上涨 {overview?.job_change.amount_increase_count}</span>
            <span className="rise-11">薪酬大幅上涨 {overview?.job_change.salary_increase_count}</span>
          </p>
          <p className="line-55"
            style={{ marginLeft: '10px' }}>
            <span className="down-11">招聘量大幅下跌 {overview?.job_change.amount_decline_count}</span>
            <span className="down-11">薪酬大幅下跌 {overview?.job_change.salary_decline_count}</span>
          </p>
        </section>
      </section>
    </section>
  );
};

export default observer(CollectCard);
